import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './SortableHeaderField.scss';
import SortArrow from 'components/controls/SortArrow';

export default function SortableHeaderField(props) {
  const {field: {name, className, label, sortable = true}, current, onChangeDirection} = props;

  const currentName = Object.keys(current)[0];
  const direction = name === currentName
    ? current[currentName]
    : 0;


  const handleChangeDirection = () => {
    onChangeDirection({
      name: name,
      direction,
    });
  }

  return (
    sortable
      ? <button
        className={classnames(styles.container, className)}
        onClick={handleChangeDirection}
      >
        {label}
        <SortArrow direction={direction} />
      </button>
      : <span
        className={classnames(styles.container, className)}
      >
        {label}
      </span>
  );
}

SortableHeaderField.propTypes = {
  field: PropTypes.object,
  onChangeDirection: PropTypes.func.isRequired,
  current: PropTypes.object,
};

SortableHeaderField.defaultProps = {
  field: {},
  current: {},
};


// WEBPACK FOOTER //
// ./src/components/controls/SortableHeaderField.jsx